// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo-text[data-v-3c5cd786]{z-index:99999}.splashscreen[data-v-3c5cd786]{z-index:200;background:#fff2eb}", ""]);
// Exports
module.exports = exports;
